export default __webpack_public_path__ + "static/media/upcase.39c67c40.svg";